/* Code generated with AutoHTML Plugin for Figma */
import { UserFrontPrivate } from "@project/shared-types";
import { useMemo, useState } from "react";
import { useLocation } from "react-router";
import MenuSvg from "../../assets/taiga-uikit/icons/menu.svg?react";
import ProfileSvg from "../../assets/taiga-uikit/icons/user-octagon.svg?react";
import { _size, _style } from "../../core/core";
import { useUser } from "../../entities/user/hooks/useUser";
import { useLocalStorage } from "../../shared/hooks/useLocalStorage";
import { Button } from "../button/button";
import { Link } from "../link/link";
import { Logo } from "../Logo/Logo";
import { Tab } from "../Tab/Tab";
import "./header.css";
import { MobileMenu } from "./MobileMenu";

const Header = ({ children }: { children?: React.ReactNode }) => {
  const user = useUser();
  const [isEnableMenu, setIsEnableMenu] = useState(false);

  const [email, setEmail] = useLocalStorage("email", "");
  const email_user = useMemo(() => {
    if (user)
      if (user.email) return user.email;
      else if (email && email.includes("@")) return email;
    return undefined;
  }, [user, email]);
  const getEmailName = (user: UserFrontPrivate): string => {
    try {
      if (user) if (user.email) return user.email.split("@")[0];
    } catch (error) {
      return "Авторизация";
    }
    return "Авторизация";
  };
  // const isWarning = () => {
  //   const currentDate = new Date();
  //   const targetDate = new Date(2025, 0, 11); // Months are zero-indexed, so 0 is January
  //   return currentDate.toDateString() === targetDate.toDateString();
  // };
  const currentPage = useLocation();
  const is_uslugi = currentPage.pathname.includes("uslugi");
  return (
    <div className="header-container">
      <div className="header-block">
        <div className="header-desktop">
          <div className="hedaer-left">
            <Logo></Logo>
            <div className="left-group">
              <Tab
                stroke={currentPage.pathname == "/uslugi/"}
                text="Каталог"
                link="/uslugi/"
              ></Tab>
              <Tab
                stroke={currentPage.pathname == "/blog/"}
                text="Блог"
                link="/blog/"
              ></Tab>
            </div>
          </div>
          {user ? (
            <div className="header-right">
              <Link link={"/account/"} size={_size.M}>
                {getEmailName(user)}
              </Link>
            </div>
          ) : (
            <div className="header-right">
              <Link
                link={`/account/`}
                style={_style.outline}
                size={_size.M}
                icon_left={<ProfileSvg />}
              >
                Вход
              </Link>
            </div>
          )}
        </div>

        <div className="header-mob">
          <div className="header-mob-left">
            <Button width={'44px'} onClick={() => setIsEnableMenu(true)} className="header-mob-burger" size={_size.M} style={_style.outline} icon_left={<MenuSvg />}></Button>
          </div>
          <div className="header-mob-center">
            <Logo></Logo>
          </div>
          <div className="header-mob-right">
            <Button width={'94px'} size={_size.M} style={_style.outline} >Войти</Button>
          </div>
        </div>
      </div>
      <MobileMenu is_active={isEnableMenu} set_is_active={setIsEnableMenu} />
      {children}
    </div>
  );
};

export default Header;
